angular.module('units', ['core'])
    .factory('Unit', function ($resource) {
        let Unit = $resource('/crm/api/units/:id', {}, {
            list: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/units/table'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
        Unit.getDefault = items => items.find(item => item.defaultValue === true)
        return Unit
    })
    .service('UnitService', function ($rootScope, toastr, modals, Unit, $filter) {
        this.editModal = entity => modals.open('app/unit/edit-modal.html', 'UnitDialogController', angular.copy(entity), {size: 'md'}, "$ctrl")
        this.addModal = () => {
            let entity = {
                isActive: true,
                id: null
            }
            return this.editModal(entity)
        }
        this.remove = item => {
            return modals.confirmDelete($filter("localized")(item.name), () => Unit.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('unit.updated')));
        }
    })
    .component('unitList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/unit/list.html',
        controller: function ($scope, $state, $stateParams, Unit, UnitService) {
            this.UnitService = UnitService
            this.reset = () => this.filters = {}

            $scope.$on('unit.updated', () => $state.reload());
        }
    })
    .controller('UnitDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, Unit) {
        this.item = data
        this.cancel = () => $uibModalInstance.dismiss('Canceled')

        this.onLanguageChanged = (language) => {
            this.currentLang = language
        }

        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = Unit.update(this.item).$promise
            } else {
                promise = Unit.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('unit.updated')
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('unitList', {
            parent: 'app',
            url: '/unit?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': "unitList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (Unit, $stateParams) => Unit.table(angular.copy($stateParams)).$promise
            }
        })
    })
